import common from "@/common/constants.js";

const state = {
  globalConst: {
    projectId: 0,
    taskId: 0,
    datasetId: 0,
    dashboardTab: "summary",
    commonHeaderTab: "PROJECT",
    priceDataChange: {
      fileChange: false,
      classChange: false,
    },

    dashboardTreeOptions: {
      keyword: "",
      limit: common.COMMON_LIST_LIMIT,
      order: common.COMMON_LIST_ORDER,
      page: 1,
    },
  },
};

const mutations = {
  setProjectId(state, payload) {
    state.globalConst.projectId = payload;
  },
  setTaskId(state, payload) {
    state.globalConst.taskId = payload;
  },
  setDatasetId(state, payload) {
    state.globalConst.datasetId = payload;
  },
  setDashboardTab(state, payload) {
    state.globalConst.dashboardTab = payload;
  },
  setDashboardTreeOptions(state, payload) {
    state.globalConst.dashboardTreeOptions = payload;
  },
  setCommonHeaderTab(state, payload) {
    state.globalConst.commonHeaderTab = payload;
  },
  setFileChange(state, payload) {
    state.globalConst.priceDataChange.fileChange = payload;
  },
  setClassChange(state, payload) {
    state.globalConst.priceDataChange.classChange = payload;
  },
  clearDadhboardTreeOptions(state) {
    state.globalConst.dashboardTreeOptions = {
      keyword: "",
      limit: common.COMMON_LIST_LIMIT,
      order: common.COMMON_LIST_ORDER,
      page: 1,
    };
  },
  clearHistory(state) {
    state.globalConst = {
      projectId: 0,
      taskId: 0,
      datasetId: 0,
      dashboardTab: "summary",
      commonHeaderTab: "PROJECT",
      priceDataChange: {
        fileChange: false,
        classChange: false,
      },
      dashboardTreeOptions: {
        keyword: "",
        limit: common.COMMON_LIST_LIMIT,
        order: common.COMMON_LIST_ORDER,
        page: 1,
      },
    };
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
